.Page {
  max-width: 64rem;
  margin: 0 auto;
  padding: clamp(1.5rem, 4vw, 3rem) clamp(0.5rem, 3vw, 1.5rem) 4rem;
  color: #1f2937;
}

.Hero {
  padding: clamp(2rem, 5vw, 4rem) 1rem;
  text-align: center;
}

.Tagline {
  margin: 0 0 0.75rem;
  color: var(--bs-primary, #0d6efd);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.Title {
  margin: 0;
  font-size: clamp(2.5rem, 6vw, 4.75rem);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1;
}

.Subtitle {
  margin: 1rem 0 0;
  color: #4b5563;
  font-size: clamp(1.1rem, 2vw, 1.4rem);
}

.Introduction {
  max-width: 48rem;
  margin: 0 auto 3rem;
  color: #4b5563;
  font-size: 1.05rem;
  line-height: 1.7;
  text-align: center;
}

.Guides {
  display: grid;
  gap: 3rem;
}

.Guide {
  scroll-margin-top: 1rem;
  text-align: center;
}

.Guide h2 {
  margin: 0;
  font-size: clamp(1.35rem, 3vw, 1.75rem);
  line-height: 1.25;
}

.Guide p {
  max-width: 44rem;
  margin: 0.75rem auto 1.5rem;
  color: #4b5563;
  line-height: 1.65;
}

.VideoFrame {
  width: min(100%, 37.5rem);
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 0.75rem;
  background: #111827;
  box-shadow: 0 20px 45px -30px rgba(17, 24, 39, 0.6);
}

.VideoFrame iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.Support {
  margin-top: 1rem;
  padding: 2rem;
  border-radius: 1rem;
  background: #f3f7fb;
  text-align: center;
}

.Support h2 {
  margin: 0;
  font-size: 1.5rem;
}

.Support p {
  margin: 0.75rem 0 0;
}

.Support a {
  color: var(--bs-primary, #0d6efd);
  font-weight: 700;
}
